/**
 * Die Stufen nach Vertragsende (§ 10 Abs. 3 AVV) — gerechnet wird sie im Backend, hier steht nur der Name.
 */
export enum OrgLifecycle {

  ACTIVE = 'ACTIVE',
  EXPORT_WINDOW = 'EXPORT_WINDOW',
  BLOCKED = 'BLOCKED',
  DUE = 'DUE',
}
